import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import type { ChdLang } from './resources';
import { getPreferredLang, isChdLang, localePath } from './localePath';

/** 当前 URL 语言 + 生成 /{lang}/... 路径 */
export function useLocalePath() {
  const { lang } = useParams<{ lang: string }>();
  const current: ChdLang = isChdLang(lang) ? lang : getPreferredLang();

  const lp = useCallback(
    (path: string) => localePath(path, current),
    [current],
  );

  return { lang: current, localePath: lp };
}
